<template>
  <v-form ref="form" v-model="validacion" lazy-validation>
    <v-layout v-if="tipeView != 'aprobacion'">
      <v-flex xs12 md6>
        <v-select
          v-model="centroCapacitacionValue"
          :items="centroCapacitacionSelect"
          item-value="code"
          item-text="nombre"
          :error-messages="centroCapacitacionErrors"
          label="Centro de Capacitación"
          :box="isDisabledEdit"
          :readonly="isDisabledEdit"
          @blur="
            tipeView == 'crear' ? $v.centroCapacitacionValue.$touch() : null
          "
        ></v-select>
        <v-select
          v-model="tipoCapacitacionValue"
          :items="tipoCapacitacionSelect"
          item-text="nombre"
          item-value="code"
          :error-messages="tipoCapacitacionErrors"
          label="Tipo de Capacitacion"
          :box="isDisabledEdit"
          :readonly="isDisabledEdit"
          @focusout="datosRelator"
          @blur="tipeView == 'crear' ? $v.tipoCapacitacionValue.$touch() : null"
        ></v-select>
        <v-text-field
          v-model="sala"
          label="Sala de capacitación"
          :error-messages="salaErrors"
          :box="isDisabledEdit"
          :readonly="isDisabledEdit"
          @input="$v.sala.$touch()"
          @blur="tipeView == 'crear' ? $v.sala.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="convocados"
          label="N° Convocados"
          :error-messages="convocadosErrors"
          :box="isDisabledEdit"
          :readonly="isDisabledEdit"
          @input="$v.convocados.$touch()"
          @blur="tipeView == 'crear' ? $v.convocados.$touch() : null"
        ></v-text-field>
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="fechaCapacitacion"
              label="Fecha Capacitación"
              prepend-icon="event"
              :error-messages="fechaCapacitacionErrors"
              :box="isDisabledEdit"
              :readonly="isDisabledEdit"
              v-on="on"
              @blur="tipeView == 'crear' ? $v.fechaCapacitacion.$touch() : null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fechaCapacitacion"
            no-title
            @input="menu1 = false"
            locale="es"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
        <v-flex xs5 style="display: inline-block">
          <v-dialog
            ref="dialog1"
            v-model="modalTimeInicio"
            :return-value.sync="horaInicio"
            persistent
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="horaInicio"
                :box="isDisabledEdit"
                label="Hora Inicio"
                :error-messages="horaInicioErrors"
                prepend-icon="access_time"
                readonly
                v-on="on"
                @blur="tipeView == 'crear' ? $v.horaInicio.$touch() : null"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modalTimeInicio"
              v-model="horaInicio"
              full-width
              :max="horaFin"
              scrollable
            >
              <div class="flex-grow-1"></div>
              <v-btn text color="primary" @click="modalTimeInicio = false"
                >Cancelar</v-btn
              >
              <v-btn
                text
                color="primary"
                @click="$refs.dialog1.save(horaInicio)"
                >OK</v-btn
              >
            </v-time-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs2 style="display: inline-block">&nbsp;&nbsp;&nbsp;</v-flex>
        <v-flex xs5 style="display: inline-block">
          <v-dialog
            ref="dialog2"
            v-model="modalTimeFin"
            :return-value.sync="horaFin"
            persistent
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="horaFin"
                label="Hora Fin"
                :box="isDisabledEdit"
                :error-messages="horaFinErrors"
                prepend-icon="access_time"
                readonly
                v-on="on"
                @blur="tipeView == 'crear' ? $v.horaFin.$touch() : null"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modalTimeFin"
              v-model="horaFin"
              full-width
              :min="horaInicio"
              scrollable
            >
              <div class="flex-grow-1"></div>
              <v-btn text color="primary" @click="modalTimeFin = false"
                >Cancelar</v-btn
              >
              <v-btn text color="primary" @click="$refs.dialog2.save(horaFin)"
                >OK</v-btn
              >
            </v-time-picker>
          </v-dialog>
        </v-flex>
      </v-flex>
      <v-flex xs12 md1></v-flex>
      <v-flex xs12 md6>
        <v-text-field
          v-model="rutRelator"
          label="Rut Relator Capacitación"
          counter="10"
          maxlength="10"
          :error-messages="rutRelatorErrors"
          :box="isDisabledEdit"
          :readonly="isDisabledEdit"
          @input="dvRut()"
          @focusout="datosRelator"
          @blur="tipeView == 'crear' ? $v.rutRelator.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="nombreRelator"
          label="Nombre Relator"
          :box="true"
          readonly
        ></v-text-field>
        <v-text-field
          v-model="paternoRelator"
          label="Apellido Paterno Relator"
          :box="true"
          readonly
        ></v-text-field>
        <v-text-field
          v-model="maternoRelator"
          label="Apellido Materno Relator"
          :box="true"
          readonly
        ></v-text-field>
      </v-flex>
    </v-layout>
    <br />
    <br />
    <v-layout v-if="tipeView != 'crear'">
      <v-flex xs12 md6>
        <v-text-field
          v-model="rutRelatorReal"
          label="Rut Relator Real Capacitación"
          counter="10"
          maxlength="10"
          :error-messages="rutRelatorRealErrors"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="dvRutReal()"
          @focusout="datosRelatorReal"
          @blur="tipeView == 'crear' ? $v.rutRelatorReal.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="nombreRelatorReal"
          label="Nombre Relator Real"
          :box="true"
          readonly
        ></v-text-field>
        <v-text-field
          v-model="paternoRelatorReal"
          label="Apellido Paterno Relator Real"
          :box="true"
          readonly
        ></v-text-field>
        <v-text-field
          v-model="maternoRelatorReal"
          label="Apellido Materno Relator Real"
          :box="true"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md1></v-flex>
      <v-flex xs12 md6>
        <v-text-field
          v-model="asistentes"
          label="N° Asistentes"
          :error-messages="asistentesErrors"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.asistentes.$touch()"
          @blur="tipeView == 'crear' ? $v.asistentes.$touch() : null"
        ></v-text-field>
        <v-flex xs5 style="display: inline-block">
          <v-dialog
            ref="dialog3"
            v-model="modalTimeInicioReal"
            :return-value.sync="horaInicioReal"
            persistent
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="horaInicioReal"
                :box="isDisabled"
                label="Hora Inicio Real"
                prepend-icon="access_time"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modalTimeInicioReal"
              v-model="horaInicioReal"
              full-width
              :max="horaFinReal"
              scrollable
            >
              <div class="flex-grow-1"></div>
              <v-btn text color="primary" @click="modalTimeInicioReal = false"
                >Cancelar</v-btn
              >
              <v-btn
                text
                color="primary"
                @click="$refs.dialog3.save(horaInicioReal)"
                >OK</v-btn
              >
            </v-time-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs2 style="display: inline-block">&nbsp;&nbsp;&nbsp;</v-flex>
        <v-flex xs5 style="display: inline-block">
          <v-dialog
            ref="dialog4"
            v-model="modalTimeFinReal"
            :return-value.sync="horaFinReal"
            persistent
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="horaFinReal"
                :box="isDisabled"
                label="Hora Fin Real"
                prepend-icon="access_time"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modalTimeFinReal"
              v-model="horaFinReal"
              full-width
              :min="horaInicioReal"
              scrollable
            >
              <div class="flex-grow-1"></div>
              <v-btn text color="primary" @click="modalTimeFinReal = false"
                >Cancelar</v-btn
              >
              <v-btn
                text
                color="primary"
                @click="$refs.dialog4.save(horaFinReal)"
                >OK</v-btn
              >
            </v-time-picker>
          </v-dialog>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout v-if="tipeView != 'crear'">
      <v-flex xs12>
        <v-textarea
          v-model="observaciones"
          solo
          name="input-7-4"
          label="Observaciones adicionales.."
          :box="isDisabled"
          :readonly="isDisabled"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-card-actions class="pb-3">
      <v-btn
        v-if="tipeView == 'consulta' ? false : true"
        color="primary"
        dark
        :loading="loading"
        class="mb-2"
        @click="save()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import { error } from "util";

export default {
  name: "sesiones-formativa-data",
  components: {},
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: "",
    id: "",
  },
  data() {
    return {
      allowSpaces: false,
      loading: false,
      menu1: false,
      menu2: false,
      modalTimeInicio: false,
      modalTimeFin: false,
      modalTimeInicioReal: false,
      modalTimeFinReal: false,
      horaInicio: null,
      horaFin: null,
      horaInicioReal: null,
      horaFinReal: null,
      fechaCapacitacion: "",
      user: "",
      centroCapacitacionValue: "",
      centroCapacitacionSelect: [],
      sala: "",
      tipoCapacitacionValue: "",
      tipoCapacitacionSelect: [],
      rutRelator: "",
      dvRelator: "",
      nombreRelator: "",
      paternoRelator: "",
      maternoRelator: "",
      convocados: "",
      estadoSesion: "",
      asistentes: "",
      rutRelatorReal: "",
      nombreRelatorReal: "",
      paternoRelatorReal: "",
      maternoRelatorReal: "",
      observaciones: "",
      fechaObservaciones: "",
      idRelator: "",
      idRelatorReal: "",
    };
  },

  validations: {
    rutRelator: { required },
    centroCapacitacionValue: { required },
    tipoCapacitacionValue: { required },
    fechaCapacitacion: { required },
    horaInicio: { required },
    horaFin: { required },
    convocados: { required },
    sala: { required },
  },

  created() {
    this.user = this.$store.getters.userLogged.tipo;
    if (this.tipeView === undefined) {
      this.tipeView = this.$route.params.tipeView;
    }
    if (this.tipeView == "consulta") {
      this.loadData();
    }
    if (this.tipeView == "crear") {
      this.loadCentros();
      this.loadTipoCapacitaciones();
    }
    if (this.tipeView == "modifica") {
      this.loadData();
    }
  },
  mounted() {
    this.idContrato = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.subProTabSelectedStored;
  },
  computed: {
    rutRelatorErrors() {
      const errors = [];
      if (!this.$v.rutRelator.$dirty) return errors;
      !this.$v.rutRelator.required &&
        errors.push("Rut relator es obligatorio.");
      return errors;
    },
    centroCapacitacionErrors() {
      const errors = [];
      if (!this.$v.centroCapacitacionValue.$dirty) return errors;
      !this.$v.centroCapacitacionValue.required &&
        errors.push("Debe seleccionar un centro de capacitación.");
      return errors;
    },
    tipoCapacitacionErrors() {
      const errors = [];
      if (!this.$v.tipoCapacitacionValue.$dirty) return errors;
      !this.$v.tipoCapacitacionValue.required &&
        errors.push("Debe seleccionar un tipo de capacitación");
      return errors;
    },
    fechaCapacitacionErrors() {
      const errors = [];
      if (!this.$v.fechaCapacitacion.$dirty) return errors;
      !this.$v.fechaCapacitacion.required &&
        errors.push("La fecha de la capacitación es requerida");
      return errors;
    },
    horaInicioErrors() {
      const errors = [];
      if (!this.$v.horaInicio.$dirty) return errors;
      !this.$v.horaInicio.required &&
        errors.push("La Hora de inicio es requerida");
      return errors;
    },
    horaFinErrors() {
      const errors = [];
      if (!this.$v.horaFin.$dirty) return errors;
      !this.$v.horaFin.required && errors.push("La Hora de fin es requerida");
      return errors;
    },
    convocadosErrors() {
      const errors = [];
      if (!this.$v.convocados.$dirty) return errors;
      !this.$v.convocados.required &&
        errors.push("El N° de convocados es requerido");
      return errors;
    },
    salaErrors() {
      const errors = [];
      if (!this.$v.sala.$dirty) return errors;
      !this.$v.sala.required &&
        errors.push("El número de la sala es requerido.");
      return errors;
    },

    isDisabled() {
      if (this.tipeView == "consulta") {
        return true;
      }
    },

    isDisabledEdit() {
      if (this.tipeView == "modifica" || this.tipeView == "consulta") {
        return true;
      }
    },
  },
  methods: {
    dvRut() {
      let f = this.formateaRut(this.rutRelator);
      if (f == undefined) {
        this.rutRelator = this.rutRelator;
      } else {
        this.rutRelator = f;
      }
    },
    dvRutReal() {
      let f = this.formateaRut(this.rutRelatorReal);
      if (f == undefined) {
        this.rutRelatorReal = this.rutRelatorReal;
      } else {
        this.rutRelatorReal = f;
      }
    },
    async loadData() {
      let hir = "";
      let hfr = "";

      this.documento = await this.loadSesionFormativa();

      if (this.documento.horaInicioCapacitacionReal != null) {
        hir = this.formatoHora(this.documento.horaInicioCapacitacionReal);
      }
      if (this.documento.horaFinCapacitacionReal != null) {
        hfr = this.formatoHora(this.documento.horaFinCapacitacionReal);
      }
      this.nombreRelator = this.documento.nombreRelator;
      this.paternoRelator = this.documento.paternoRelator;
      this.maternoRelator = this.documento.maternoRelator;
      this.rutRelator = this.documento.rutRelator;
      this.sala = this.documento.salaCapacitacion;
      this.convocados = this.documento.convocados;
      this.fechaCapacitacion = this.documento.fechaCapacitacion;
      this.horaInicio = this.formatoHora(this.documento.horaInicioCapacitacion);
      this.horaFin = this.formatoHora(this.documento.horaFinCapacitacion);
      this.nombreRelatorReal = this.documento.nombreRelatorReal;
      this.paternoRelatorReal = this.documento.paternoRelatorReal;
      this.maternoRelatorReal = this.documento.maternoRelatorReal;
      this.rutRelatorReal = this.documento.rutRelatorReal;
      this.asistentes = this.documento.asistentes;
      this.horaInicioReal = hir;
      this.horaFinReal = hfr;
      this.observaciones = this.documento.observaciones;
      this.centroCapacitacionValue = this.documento.idCentro;
      this.tipoCapacitacionValue = this.documento.idTipoCapacitacion;

      this.loadTipoCapacitaciones();
      this.loadCentros();
    },
    async loadSesionFormativa() {
      let idContrato = this.$store.getters.contratoStored;
      let idSesion = this.id;
      return await axios
        .get("/sesionFormativa/" + idSesion + "/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    datosRelator() {
      if (this.tipoCapacitacionValue == "") {
        window.getApp.$emit("ERROR_TIPO_CAPACITACION");
      } else {
        let v = this.validaRut(this.rutRelator);
        if (v == true) {
          let dv = this.obtenerDv(this.rutRelator);
          let rut = this.obtenerSoloRut(this.rutRelator);
          let idContrato = this.$store.getters.contratoStored;
          let idTipoCapacitacion = this.tipoCapacitacionValue;
          axios
            .get(
              "/relator/" +
                rut +
                "/" +
                dv +
                "/" +
                idTipoCapacitacion +
                "/" +
                idContrato
            )
            .then((response) => {
              this.idRelator = response.data.id;
              this.nombreRelator = response.data.nombre;
              this.paternoRelator = response.data.apellido1;
              this.maternoRelator = response.data.apellido2;
            })
            .catch((error) => {
              if (error) {
                this.nombreRelator = "";
                this.paternoRelator = "";
                this.maternoRelator = "";
                window.getApp.$emit(
                  "ERROR_EXCEPTION",
                  error.response.data.message
                );
              }
              return [];
            });
        } else {
          window.getApp.$emit("ERROR_RUT");
        }
      }
    },
    datosRelatorReal() {
      if (this.tipoCapacitacionValue == "") {
        window.getApp.$emit("ERROR_TIPO_CAPACITACION");
      } else {
        let v = this.validaRut(this.rutRelatorReal);
        if (v == true) {
          let dv = this.obtenerDv(this.rutRelatorReal);
          let rut = this.obtenerSoloRut(this.rutRelatorReal);
          let idContrato = this.$store.getters.contratoStored;
          let idTipoCapacitacion = this.tipoCapacitacionValue;
          axios
            .get(
              "/relator/" +
                rut +
                "/" +
                dv +
                "/" +
                idTipoCapacitacion +
                "/" +
                idContrato
            )
            .then((response) => {
              this.idRelatorReal = response.data.id;
              this.nombreRelatorReal = response.data.nombre;
              this.paternoRelatorReal = response.data.apellido1;
              this.maternoRelatorReal = response.data.apellido2;
            })
            .catch((error) => {
              if (error) {
                this.nombreRelatorReal = "";
                this.paternoRelatorReal = "";
                this.maternoRelatorReal = "";
                window.getApp.$emit(
                  "ERROR_EXCEPTION",
                  error.response.data.message
                );
              }
              return [];
            });
        } else {
          window.getApp.$emit("ERROR_RUT");
        }
      }
    },

    submit() {
      this.$v.$touch();
    },

    async loadCentros() {
      this.centrosData = await this.loadCentrosData();
      let centro = [];
      this.centrosData.forEach(function (e) {
        centro.push({
          nombre: e.codCentro,
          code: e.id,
        });
      });
      this.centroCapacitacionSelect = centro;
    },

    async loadCentrosData() {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/centros/capacitacion/" + idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error.response.data.message);
        });
    },
    async loadTipoCapacitaciones() {
      this.capacitacionesData = await this.loadTipoCapacitacionesData();
      let cap = [];
      this.capacitacionesData.forEach(function (e) {
        cap.push({
          nombre: e.descripcion,
          code: e.id,
        });
      });
      this.tipoCapacitacionSelect = cap;
    },
    async loadTipoCapacitacionesData() {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/tiposCapacitaciones/" + idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    save() {
      if (this.tipeView == "crear") {
        this.saveSesion();
      } else {
        this.editSesion();
      }
    },
    saveSesion() {
      this.loading = true;
      this.$v.$touch();
      let idContrato = this.$store.getters.contratoStored;
      let dv = this.obtenerDv(this.rutRelator);
      let rut = this.obtenerSoloRut(this.rutRelator);
      let v = this.validaRut(this.rutRelator);

      if (v == false) {
        this.loading = false;
        window.getApp.$emit("ERROR_RUT");
        this.location.reload();
      } else if (
        this.tipoCapacitacionValue == "" ||
        this.centroCapacitacionValue == "" ||
        this.sala == "" ||
        this.convocados == "" ||
        this.fechaCapacitacion == "" ||
        this.horaInicio == "" ||
        this.horaFin == "" ||
        this.rutRelator == ""
      ) {
        this.loading = false;
        window.getApp.$emit("DATOS_INCOMPLETOS");
        this.location.reload();
      } else {
        this.body = {
          idContrato: idContrato,
          idCentro: this.centroCapacitacionValue,
          salaCapacitacion: this.sala,
          idTipoCapacitacion: this.tipoCapacitacionValue,
          fechaCapacitacion: this.formatoFecha(this.fechaCapacitacion),
          horaInicioCapacitacion: this.horaInicio,
          horaFinCapacitacion: this.horaFin,
          idRelator: this.idRelator,
          convocados: this.convocados,
          estadoSesion: 0,
          asistentes: null,
        };
      }
      axios
        .post("/sesionFormativa", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loading = false;
          this.back();
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log(error.response.data.defaultMessage);
          } else if (error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
          this.loading = false;
        });
    },
    editSesion() {
      this.loading = true;
      this.$v.$touch();
      let idContrato = this.$store.getters.contratoStored;
      let dv = this.obtenerDv(this.rutRelatorReal);
      let rut = this.obtenerSoloRut(this.rutRelatorReal);
      let v = this.validaRut(this.rutRelatorReal);

      if (v == false) {
        this.loading = false;
        window.getApp.$emit("ERROR_RUT");
        this.location.reload();
      } else {
        this.body = {
          id: this.id,
          idContrato: idContrato,
          estadoSesion: 1,
          asistentes: this.asistentes,
          horaInicioCapacitacionReal: this.horaInicioReal,
          horaFinCapacitacionReal: this.horaFinReal,
          observaciones: this.observaciones,
          idRelatorReal: this.idRelatorReal,
        };
      }
      axios
        .put("/sesionFormativa", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loading = false;
          this.back();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          this.loading = false;
          console.log(error);
        });
    },

    back() {
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    },
    formatoFecha(f) {
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
    formatoFechaView(f) {
      return f.replace(/^(\d{2})-(\d{2})-(\d{4})$/g, "$3-$2-$1");
    },
    formatoHora(f) {
      return f.replace(/^(\d{2}):(\d{2}):(\d{2})$/g, "$1:$2");
    },
  },
};
</script>
